import type React from 'react'

/** Corner bracket decorations — matches ClassicStudyPage flashcard style. */
export default function BracketCorners() {
  const base: React.CSSProperties = { position: 'absolute', width: 16, height: 16, opacity: 0.2 }
  const ln: React.CSSProperties = { position: 'absolute', background: 'var(--text-primary)' }
  type Corner = { top?: number; bottom?: number; left?: number; right?: number; t?: true; b?: true; l?: true; r?: true }
  const corners: Corner[] = [
    { top: 12, left: 12,  t: true, l: true  },
    { top: 12, right: 12, t: true, r: true  },
    { bottom: 12, left: 12,  b: true, l: true },
    { bottom: 12, right: 12, b: true, r: true },
  ]
  return (
    <>
      {corners.map((c, i) => (
        <div key={i} style={{ ...base, top: c.top, bottom: c.bottom, left: c.left, right: c.right }}>
          {'t' in c && <div style={{ ...ln, top: 0, left: 0, right: 0, height: 2 }} />}
          {'b' in c && <div style={{ ...ln, bottom: 0, left: 0, right: 0, height: 2 }} />}
          {'l' in c && <div style={{ ...ln, top: 0, bottom: 0, left: 0, width: 2 }} />}
          {'r' in c && <div style={{ ...ln, top: 0, bottom: 0, right: 0, width: 2 }} />}
        </div>
      ))}
    </>
  )
}
